import { IPluginPresenter } from '@makyoapp/makyo-sdk/models/Plugins'
import { PluginAdapter } from '@makyoapp/makyo-common'

export function fromSdkPluginList(items: IPluginPresenter[], lang = 'en') {
  return items.map((i) => fromSdkPlugin(i, lang))
}

export function fromSdkPlugin(item: IPluginPresenter, lang = 'en'): PluginAdapter {
  return {
    id: item._id,
    icon: item._Icon,
    name: item._Name,
    author: {
      id: '',
      email: '',
      avatar: item._DeveloperLogo,
      name: item._Developer,
    },
    isInstalled: item._Active,
    details: '',
    categories: [item._Category],
    types: [],
    version: item._Version,
    rating: undefined,
    price: 'free',
    description: item._Notes[lang],
    reviews: [],
    installCount: 0,
    screenshots: [],
    updated: new Date(item._UpdatedAt),
    instructions: '',
    isActive: false, // TODO: handle this field by checking if there is at least one active instance of the plugin for the organization
    backend: item._Backend,
    frontend: item._Frontend,
    auth: {
      type: item._Auth._Type as 'oauth2',
      label: item._Auth._Label as any,
      description: item._Auth._Description as any,
    },
  }
}
